import { useMemo } from 'react';

const useStyleOverrides = (base, overrides = {}) => (
  useMemo(() => {
    const fullStyles = {};
    const allKeys = [].concat(Object.keys(base), Object.keys(overrides));

    (new Set(allKeys)).forEach((key) => {
      const baseValue = base[key] || '';
      const overrideValue = overrides[key] || '';

      fullStyles[key] = `${baseValue} ${overrideValue}`.trim();
    });

    return fullStyles;
  }, [base, overrides]));

export default useStyleOverrides;
